import React, {
    forwardRef,
    useImperativeHandle,
    useRef,
    useState,
} from 'react';
import { Form } from '@availity/form';
import * as yup from 'yup';
import { TimelineActionType } from '../../../../slices/marketplace/timeline/models/timeline-action-type.model';
import { MarketplaceDocumentSectionFieldValidator } from '../DocumentSectionField/MarketplaceDocumentSectionFieldValidator';
import {
    defaultTimelineAction,
    TimelineAction,
} from '../../../../slices/marketplace/timeline/models/timeline-actions.model';
import { ActionDocumentType } from '../../../../slices/marketplace/timeline/models/enums/action-document-type.enum';
import { TimelineParty } from '../../../../slices/marketplace/timeline/models/enums/timeline-party.enum';
import { EngagementDocumentSource } from '../../../../slices/marketplace/timeline/models/enums/engagement-document-source';
import { MarketplaceDocumentSectionField } from '../DocumentSectionField/MarketplaceDocumentSectionField';
import {
    createDefaultDocumentDetails,
    DocumentDetails,
} from '../../../../slices/marketplace/timeline/models/document-details.model';
import { DocumentSection } from '../../../../slices/marketplace/timeline/models/document-section.model';

interface BuyerUploadDocumentFormProps {
    party: TimelineParty;
    onSubmit(action: TimelineAction, documentDetails?: DocumentDetails): void;
    disabled: boolean;
    documentDetails?: DocumentDetails;
    documentDetailsList: DocumentDetails[];
    documentsSections: DocumentSection[];
    setDocumentSectionList(sections: DocumentSection[]): void;
}

export const BuyerUploadDocumentForm = forwardRef(
    (props: BuyerUploadDocumentFormProps, ref) => {
        const formRef = useRef<any>();

        useImperativeHandle(ref, () => ({
            handleSubmit() {
                formRef?.current?.handleSubmit();
            },
        }));

        const [documentDetails, setDocumentDetails] = useState({
            ...(props.documentDetails ??
                createDefaultDocumentDetails(
                    true,
                    undefined,
                    ActionDocumentType.Downloadable,
                    undefined,
                    EngagementDocumentSource.BuyerUpload,
                    TimelineParty.VetValue
                )),
        });

        return (
            <Form
                innerRef={formRef}
                initialValues={{
                    actionType: TimelineActionType.BuyerUploadDocument,
                    documentSection: documentDetails.sectionId,
                }}
                validationSchema={yup.object().shape({
                    documentSection:
                        MarketplaceDocumentSectionFieldValidator.documentSectionValidationRules(
                            props.documentsSections,
                            props.party
                        ),
                })}
                onSubmit={(values) => {
                    let docDetails = {
                        ...documentDetails,
                        name: 'NA',
                        sectionId: values.documentSection,
                    };

                    props.onSubmit(
                        {
                            ...defaultTimelineAction,
                            actionType: values.actionType,
                            referenceItemId: docDetails.id,
                        },
                        docDetails
                    );
                }}>
                <MarketplaceDocumentSectionField
                    disabled={props.disabled}
                    documentDetailsList={props.documentDetailsList}
                    documentsSections={props.documentsSections}
                    setDocumentSectionList={props.setDocumentSectionList}
                    type={'buyers'}
                    sectionsModalMode={'built-in'}
                />
            </Form>
        );
    }
);
